import AssetTypeDataGrid from './AssetTypeDataGrid';

export default AssetTypeDataGrid;
export * from './AssetTypeDataGrid';
